import ItemsList from "common/Lists/ItemsList";
import { ListItem } from "common/Lists/types";
import { getItem } from "common/Lists/utils";
import { useMemo } from "react";
import { LanguageNameSpaces } from "@shared/types";
import { ICON_TYPES } from "@shared/common/constants";
import { sharedLib } from "@shared/services/shared.service";
import useTypedTranslation from "@shared/common/i18n/useTypedTranslation";

interface SymbolsListProps {
  handleSelectSymbol: (symbol: string) => void;
}

const SymbolsList = ({ handleSelectSymbol }: SymbolsListProps) => {
  const { t } = useTypedTranslation(LanguageNameSpaces.PORTFOLIO);
  const {
    data: symbols,
    isFetching: loading,
    isSuccess: loaded,
  } = sharedLib.sharedApi.trades.useGetSymbolsQuery();
  const {
    active_symbols: activeSymbolsList,
    inactive_symbols: inactiveSymbolsList,
  } = (symbols || { active_symbols: [], inactive_symbols: [] }) as {
    active_symbols: string[];
    inactive_symbols: string[];
  };

  const getErrorMessage = (symbol: string) => {
    return t("errors.no_account_for_symbol", { symbol });
  };

  const items = useMemo(() => {
    let items: ListItem<string>[] = [];
    items = activeSymbolsList.reduce((acc, symbol) => {
      acc.push(getItem(symbol, symbol, symbol));
      return acc;
    }, items);
    items = inactiveSymbolsList.reduce((acc, symbol) => {
      acc.push(getItem(symbol, symbol, undefined, getErrorMessage(symbol)));
      return acc;
    }, items);
    return items;
  }, [symbols]);

  const props = {
    items,
    loading,
    loaded,
    handleSelectItem: handleSelectSymbol,
    iconType: ICON_TYPES.COIN,
  };

  return <ItemsList {...props} />;
};

export default SymbolsList;
